module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7_2.b580134a.png";